import * as React from "react";
import {
  ICourseComponentPart,
  IExerciseAnalyticsCommonProps,
  UnitChartType,
} from "../../../../../App/Analytics/Common";
import UnitInstanceAnalytics from "./UnitInstanceAnalytics";
import { ExercisesSectionTitle } from "../UnitsAnalytics.styles";
import { TopicsIcon } from "../../AnalyticsIcons";

export interface IExercisesAnalyticsProps extends IExerciseAnalyticsCommonProps {
  exercises: ICourseComponentPart[];
}

const ExercisesAnalytics: React.SFC<IExercisesAnalyticsProps> = ({
  exercises,
  fetchAnalytics,
  users,
  selectedUsers,
  usersAnalytics,
  searchLocale,
  onSelectAssessmentName,
}) => {
  if (exercises.length === 0) {
    return null;
  }
  return (
    <>
      <ExercisesSectionTitle data-testid="lesson-analytics-header">
        <TopicsIcon />
        Lesson Questions
      </ExercisesSectionTitle>
      <UnitInstanceAnalytics
        courseData={exercises}
        fetchAnalytics={fetchAnalytics}
        onSelectAssessmentName={onSelectAssessmentName}
        searchLocale={searchLocale}
        selectedUsers={selectedUsers}
        users={users}
        usersAnalytics={usersAnalytics}
        type={UnitChartType.Exercises}
      />
    </>
  );
};

export default ExercisesAnalytics;
